function ShareIcon({ className }: { className?: string }) {
    return (
        <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 3v12" strokeLinecap="round" />
            <path d="M8 7l4-4 4 4" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 14v5a2 2 0 002 2h12a2 2 0 002-2v-5" strokeLinecap="round" />
        </svg>
    );
}

function PlusSquareIcon({ className }: { className?: string }) {
    return (
        <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="3" />
            <path d="M12 8v8M8 12h8" strokeLinecap="round" />
        </svg>
    );
}

function AddIcon({ className }: { className?: string }) {
    return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
        </svg>
    );
}

interface Step {
    number: number;
    title: string;
    description: string;
    icon: React.ReactNode;
}

export function IOSInstructions() {
    const steps: Step[] = [
        {
            number: 1,
            title: 'Tocá el botón Compartir',
            description: 'El ícono con una flecha hacia arriba en la barra de Safari',
            icon: <ShareIcon className="w-6 h-6 text-blue-400" />,
        },
        {
            number: 2,
            title: 'Buscá "Añadir a pantalla de inicio"',
            description: 'Desplazate hacia abajo en el menú y tocá la opción',
            icon: <PlusSquareIcon className="w-6 h-6 text-blue-400" />,
        },
        {
            number: 3,
            title: 'Tocá "Añadir"',
            description: 'Confirmá tocando Añadir en la esquina superior derecha',
            icon: <AddIcon className="w-6 h-6 text-blue-400" />,
        },
    ];

    return (
        <div className="space-y-4">
            <div className="flex items-center gap-2 text-gray-700 mb-4">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <span className="font-medium">Pasos para instalar en iOS</span>
            </div>

            <div className="space-y-3">
                {steps.map((step) => (
                    <div key={step.number} className="flex items-start gap-3 bg-gray-50 rounded-lg p-3">
                        <div className="flex-shrink-0 w-8 h-8 bg-green-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                            {step.number}
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                                <span className="text-gray-800 font-medium text-sm">{step.title}</span>
                                {step.icon}
                            </div>
                            <p className="text-gray-500 text-xs mt-0.5">{step.description}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                <p className="text-xs text-blue-700">
                    <strong>Nota:</strong> Asegurate de usar Safari. Otros navegadores en iOS no permiten agregar apps a la pantalla de inicio.
                </p>
            </div>
        </div>
    );
}
